import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AddUserModel } from './../models/UserModels/AddUserModel';
import { EditUserModel } from './../models/UserModels/EditUserModel';
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";



@Injectable({
    providedIn: 'root'
  })
export class userService  {
    ApiUrl="/api/admin/Users/"
    constructor(private http:RequestHandlerService,private authService:AuthService) {    
      }

 GetUsersByFilter(FilteredUsersRequestModel:any)
{
  return this.http.post(this.ApiUrl +'GetUsersByFilter', FilteredUsersRequestModel);
}
Loaddropdowns()
{
  return this.http.get( this.ApiUrl + 'Loaddropdowns');
}
AddUser(AddUserModel:AddUserModel)
{
  return this.http.post(this.ApiUrl +'AddUser',AddUserModel);
}

EditUser(EditUserModel:EditUserModel)
{
  
  return this.http.post(this.ApiUrl +'EditUser',EditUserModel);
}

SendActivationEmailForUser(UsersRequestModel:any)
{
  
  return this.http.post(this.ApiUrl +'SendActivationLink',UsersRequestModel);
}

ActivateUsers(UserModelsDTO:any[])
{
  
  return this.http.post(this.ApiUrl +'ActivateUsers',UserModelsDTO);
}

DeactivateUsers(UserModelsDTO:any[])
{
  
  return this.http.post(this.ApiUrl +'DeactivateUsers',UserModelsDTO);
}

ResetUsersPassword(UserModelsDTO:any[])
{
 
  return this.http.post(this.ApiUrl +'ResetUsersPassword',UserModelsDTO);
}

SetUsersPassword(UserModelsDTO:any[])
{
  return this.http.post(this.ApiUrl +'SetUsersPassword',UserModelsDTO);
}

Export(params:HttpParams)
{
  let options:RequestOptionsModel=new RequestOptionsModel()
  options.responseType="arraybuffer"

  return this.http.post(this.ApiUrl +'Export',null,params,options);
}


ChangeLanguage(key:string)
{

  let params = new HttpParams();
  params = params.append("UserId",this.authService.user.profile.id);
  params = params.append("LanguageKey",key);
  return this.http.post(this.ApiUrl +'updateLaguage',null,params)
}

UpdateUserInfo()
{

  return this.http.get('/connect/userinfo')
}

}